import SubmissionidCheck from './Submissionid_Check';
import PDFLink from './generateLink';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { downloadQuoteSubmission } from '../actions';
import {fetch} from './api';
import {getSubmission} from '../api'
import {submission as utilSubmission} from '../../utils'
import { get } from 'lodash';
import './index.scss';

class Sub_id extends Component { 
  constructor(props) {
    super(props);
    this.initialState = {
      result: {},
      error:{},
      message:'',
      pdfLink:'',
      flag:false,
     additionalCoverage:{},
     coverage:{},
     optionalCoverage:{},
    };
    this.state=this.initialState;
    this.handleSubmit=this.handleSubmit.bind(this);
    
   }
   async handleSubmit (submissionid)
   {
     let submission;
     let ratings;
     
     this.setState(this.initialState);
     try {
      if(!submissionid) {
        await this.props.getDownloadQuoteSubmission(this.props.user,'',false)
        throw 'Cleared'
      }
      try{
      submission =await getSubmission(this.props.user,{id:submissionid});
      } catch {
        throw {userAlert: 'Invalid submission id'}
      }
    const type = get(submission.data, 'type', 'default');
    const coverage=get(submission.data, 'coverages.gl.base', 'standard');
    const additionalCoverage = utilSubmission.getAdditionalCoverageSelection(
      get(submission.data, 'coverages.gl.additional', {}), type
  );

  const optionalCoverage = utilSubmission.getOptionalCoverageSelection(
      get(submission.data, 'coverages.gl.optional', {}), type
  );
  this.setState({
    coverage:coverage,
    additionalCoverage:additionalCoverage,
    optionalCoverage:optionalCoverage
  })
    let props = utilSubmission.getRatingProperties(submission.data);
    let optionslCoverage = submission.data.coverages.gl;
    let boolPCOpsExcluded = !!optionslCoverage.optional && optionslCoverage.optional.isPCOpsExcluded ? optionslCoverage.optional.isPCOpsExcluded.selected : false;
    props.isPCOpsExcluded = boolPCOpsExcluded;
    if(props.isPCOpsExcluded == true && this.state.additionalCoverage.extendedCompletedOps){
        delete this.state.additionalCoverage.extendedCompletedOps;
    }
    if(!props.dateOfCreation){
        props.dateOfCreation = submission.data.createdAt;
    }
    Object.assign(props, {
      additionalCoverage: Object.keys(this.state.additionalCoverage).join(','),
      optionalCoverage: Object.keys(this.state.optionalCoverage).join(','),
      baseCoverage: this.state.coverage,
    });
    props.hnoaRequired = props.additionalCoverage.includes('hnoaPremium');
     try {
     ratings=await fetch(props);
     } catch {
       throw {userAlert: 'Unable to retrieve ratings'}
     }
     
     try {
     const pdf_arr= await this.props.getDownloadQuoteSubmission(this.props.user,submissionid,false);
     } catch {
       throw {userAlert:'Unable to retrieve PDF'}
     }
  this.setState({
         pdfLink:this.props.PDFdata
       }, 
      this.setState({
        result:ratings[submission.data.type],
      }));
    }
     catch(error){
       const msg = error.userAlert? error.userAlert : 'Unknown error';
      this.setState({
        error:error,
        message:msg
      })
     }
    
   }
render(){
  return (
    <div className="App">
      <div className="">
        <div className=" split left">
<SubmissionidCheck handleSubmit={(submissionid)=>this.handleSubmit(submissionid)} err={this.state.message} error={this.state.error ||{}} ratings={this.state.result ||{}}/>
        </div>
        <div className=" split right">
          {!this.state.message && this.props.pdfStatus!='failed' && <PDFLink 
            pdfLink={this.props.PDFdata} />}
              {this.props.pdfStatus=='failed' && <h4>No PDF available</h4>}
        </div>
      </div>
    </div>
  );
}
}

const mapStateToProps = state => {
  return {
      PDFdata : state.app.PDFdata,
      pdfStatus: state.app.pdfStatus,
  };
};

export const mapDispatchToProps = dispatch => ({
  getDownloadQuoteSubmission: (user, submissionID,flag) => dispatch(downloadQuoteSubmission(user, submissionID, flag))
});

export default connect(mapStateToProps,mapDispatchToProps)(Sub_id);




